import axios from "axios";
const uri = "https://www.lefisc.com.br/api/monitoramentoNCM/cliente";
const uriAlteracoes = "buscaMonitoradas";
const uriVerMonitoramento = "verMonitorado";
const uriDeixarMonitoramento = "deixarMonitoramento";
const tok = "64ad62a25fe48a9e8bcd84df737dd40b";

export default {
  async getAlteracoes(client, qntExibido) {
    return await axios
      .get(`${uri}/${uriAlteracoes}/${qntExibido}/${client}/${tok}`)
      .then(
        res => {
          return res.data;
        },
        erro => {
          return erro.response;
        }
      );
  },

  async estaMonitorando(ncm, idCliente) {
    return await axios
      .get(`${uri}/${uriVerMonitoramento}/${ncm}/${idCliente}/${tok}`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err.response;
      });
  },

  async DeixarMonitoramento(idMonitorando) {
    return await axios
      .get(`${uri}/${uriDeixarMonitoramento}/${idMonitorando}/${tok}`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err.response;
      });
  }
};
